<template>
  <div>
    <v-card class="mx-auto my-12" :max-width="wpoint ? 350 : 280">
      <div
        style="height:150px; margin-left: auto; margin-right: auto; text-align: center; padding-top: 50px"
        class="mx-auto"
      >
        <img src="../../assets/img/LogoMin.png" alt="" />
      </div>
      <v-card-text align="center">
        <div>
          Está a usar um dispositivo móvel. Descarregue a nossa aplicação
        </div>
      </v-card-text>

      <v-card-text align="center">
        <div class="my-3">
          <a
            href="#"
            ><img
              class="m-padd-5"
              src="../../assets/img/vendor/app-google-play.svg"
              alt=""
          /></a>
          <a href="#"
            ><img
              class="m-padd-5"
              src="../../assets/img/vendor/app_store.svg"
              alt="#"
          /></a>
        </div>
      </v-card-text>
    </v-card>

    <!--    <v-card class="mx-auto my-12" max-width="280">-->
    <!--&lt;!&ndash;      <v-img&ndash;&gt;-->
    <!--&lt;!&ndash;        height="150"&ndash;&gt;-->
    <!--&lt;!&ndash;        :src="require('../../assets/img/LogoMin.png')"&ndash;&gt;-->
    <!--&lt;!&ndash;      ></v-img>&ndash;&gt;-->
    <!--      <img src="../../assets/img/LogoMin.png" alt="" />-->
    <!--      <v-card-text align="center">-->
    <!--        <div>Está a usar um dispositivo móvel</div>-->
    <!--      </v-card-text>-->
    <!--      <v-card-text align="center">-->
    <!--        <div>Baixe a nossa aplicação</div>-->
    <!--      </v-card-text>-->
    <!--      <v-card-actions>-->
    <!--        <v-btn color="deep-purple lighten-2" text block @click="() => {}">-->
    <!--          <v-icon>mdi-android-debug-bridge</v-icon>-->
    <!--          Play Store-->
    <!--        </v-btn>-->
    <!--      </v-card-actions>-->
    <!--      <v-card-actions>-->
    <!--        <v-btn color="deep-purple lighten-2" text block @click="() => {}">-->
    <!--          <v-icon>mdi-apple</v-icon>-->
    <!--          iOS Store-->
    <!--        </v-btn>-->
    <!--      </v-card-actions>-->
    <!--    </v-card>-->
  </div>
</template>

<script>
export default {
  name: "MobileView"
};
</script>

<style scoped></style>
